import { Component, OnInit } from '@angular/core';
import { OidcService, AuthService } from './core';
import { TranslateService } from '@ngx-translate/core';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  constructor(
    public translate: TranslateService,
    public authService: AuthService,
    readonly oidcService: OidcService) {
    translate.setDefaultLang('English');
  }


  ngOnInit(): void {
    const params = new URLSearchParams(window.location.search);

    if (params.has('logout')) {
      return;
    }

    this.oidcService.autoLogin();
  }

  useLanguage(language: string) {
    this.translate.use(language);
  }
}
